module.exports = __webpack_public_path__ + "static/media/bolso (38).2fb1da80.jpg";